import { m } from '#/browser-framework';


export default {
    view() {
        return m('p.LoginInstructions',
            'Please log in with your Google account using the link at the top right.');
    },
};
